import { Yup } from 'shared/lib'

export const editDescSchema = Yup.object().shape({
   description: Yup.string().nullable(),
   name: Yup.string().nullable(),
})
